module.exports = __webpack_public_path__ + "static/media/pg.114dfc45.svg";